import { useAppUpdate } from '../hooks/useAppUpdate'
import { deployedLabel } from '../lib/update'
import { t } from '../lib/i18n'

/**
 * "A newer version is ready."
 *
 * Shown at the top, above everything, because an app running old code is the
 * cause of bug reports nobody can reproduce. **Later** is a real option: an
 * update prompt that cannot be dismissed is a prompt people learn to route
 * around, and it dismisses for this session only rather than forever.
 */
export default function UpdateBar() {
  const update = useAppUpdate()
  if (!update.available) return null
  const label = deployedLabel(update.available)

  return (
    <div className="update-bar" role="status">
      <span>{t('update.ready')}{label ? ` — ${label}` : ''}</span>
      <span className="row">
        <button className="primary" onClick={update.reload}>{t('update.now')}</button>
        <button onClick={update.dismiss}>{t('update.later')}</button>
      </span>
    </div>
  )
}
